// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-information[data-v-687d5af1]{font-size:16px;line-height:19px;letter-spacing:-.25px;text-align:left;font-weight:700}", ""]);
// Exports
module.exports = exports;
